import React, { useEffect, Suspense } from "react";
import Card from "../../components/Card";
import { getStores } from "../../store/actions/Store";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";

import { setStore } from "../../store/actions/Store/selectedStore";
import { getAllStores } from "../../store/services/Store";
import { getUserProfile } from "store/services/Profile/profile";
import { setProfile } from "store/actions/Profile/profile";
import Loader from "components/Loader";

const ExploreData = () => {
  const dispatch = useDispatch();
  const { data } = useSelector((store) => store.storeReducer);
  const { user, isAuthenticated } = useSelector((store) => store.userReducer);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await getAllStores();
        if (result.data) {
          dispatch(getStores(result.data));
        }
        if (user) {
          const profile = await getUserProfile(user.accessToken, user.data.id);
          if (profile.success) {
            dispatch(setProfile(profile.data));
          }
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, [dispatch, user]);

  const handleStoreSelect = (selectedStore) => {
    dispatch(setStore(selectedStore));
  };

  if (!data || data.length === 0 || !data.stores) {
    return <Loader />;
  }

  return (
    <div className="flex flex-col items-center justify-center h-screen mt-16 overflow-hidden md:mt-0 lg:mt-0 ">
      <h1 className="flex flex-row items-center justify-center mt-12 text-3xl font-bold text-center text-black text-slate-600">
        Choose a Store
      </h1>
      <div className="grid items-center justify-center grid-cols-1 gap-6 p-8 m-12 mt-4 lg:grid-cols-2">
        {data &&
          data.stores.map((d) => (
            <Link
              to={`/stores/${d.id}/${
                isAuthenticated !== null ? "dashboard" : "items"
              }`}
              key={d.id}
              onClick={() => handleStoreSelect(d)}
            >
              <Card imgUrl={d.logo} title={d.name} location={d.location} />
            </Link>
          ))}
      </div>
    </div>
  );
};

export const Explore = () => (
  <Suspense fallback={<Loader />}>
    <ExploreData />
  </Suspense>
);
